export class AsyncUtil {
  static sleep(durationMillis: number): Promise<void> {
    return new Promise((r) => setTimeout(r, durationMillis));
  }
}
